<template>
  <div class="faq-page">
    <div class="faq-container">
      <div class="breadcrumb-bar">
        <span class="crumb" @click="$router.push('/')">首页</span>
        <span class="sep">/</span>
        <span class="crumb-current">常见问题</span>
      </div>

      <div class="faq-header">
        <h1 class="faq-title">常见问题 FAQ</h1>
        <p class="faq-subtitle">辰鳗科技集团常见问题解答。涵盖综合能源服务、零碳园区、零碳工厂、区域微电网、虚拟电厂等核心业务板块。</p>
      </div>

      <div class="faq-body">
        <div class="faq-sidebar">
          <div
            v-for="(cat, idx) in categories"
            :key="idx"
            :class="['cat-item', { active: activeCat === idx }]"
            @click="activeCat = idx"
          >
            <span class="cat-icon">{{ cat.icon }}</span>
            <span class="cat-name">{{ cat.name }}</span>
            <span class="cat-count">{{ faqMap[cat.key] ? faqMap[cat.key].length : 0 }}</span>
          </div>
        </div>

        <div class="faq-list">
          <div
            v-for="cat in categories"
            :key="cat.key"
            v-show="activeCat === categories.indexOf(cat)"
            class="cat-panel"
          >
            <h2 class="cat-title">{{ cat.name }}</h2>
            <p class="cat-desc">{{ cat.desc }}</p>
            <div
              v-for="(item, qIdx) in faqMap[cat.key]"
              :key="qIdx"
              class="faq-item"
            >
              <div class="faq-question" @click="toggle(item)">
                <span class="q-icon">Q</span>
                <span class="q-text">{{ item.question }}</span>
                <span :class="['q-arrow', { open: item.open }]">+</span>
              </div>
              <div v-show="item.open" class="faq-answer">
                <span class="a-icon">A</span>
                <span class="a-text" v-html="item.answer"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="faq-contact">
        <p>没有找到您想要的答案？</p>
        <p>请联系辰鳗科技客服：028-86533354 邮箱：xiaomanguanjia@smalleel.com</p>
      </div>
    </div>
  </div>
</template>

<script>
import { injectFAQ } from '../../untils/seo'
import faqData from './faq-data.json'

export default {
  name: 'faq',
  data() {
    // 从 JSON 文件加载分类与问题数据，并为每个问题补充 open 状态
    const faqMap = {}
    Object.keys(faqData.faqMap).forEach((key) => {
      faqMap[key] = faqData.faqMap[key].map((item) => ({ ...item, open: false }))
    })
    return {
      activeCat: 0,
      categories: faqData.categories,
      faqMap: faqMap
    }
  },
  mounted() {
    // GEO 整改 - 注入 FAQPage JSON-LD
    const allFaqs = []
    Object.values(this.faqMap).forEach((list) => {
      list.forEach((f) => {
        allFaqs.push({
          question: f.question,
          // answer 在 schema 中建议提供纯文本,这里去掉可能的 HTML 标签
          answer: (f.answer || '').replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '')
        })
      })
    })
    injectFAQ(allFaqs)

    // GEO 整改 - 根据 query.q 参数定位到对应问题并自动展开
    this.$nextTick(() => {
      const targetQ = this.$route.query.q
      if (targetQ) {
        const decodedQ = decodeURIComponent(targetQ)
        let catIndex = 0
        let targetItem = null
        const keys = Object.keys(this.faqMap)
        for (let i = 0; i < keys.length; i++) {
          const found = this.faqMap[keys[i]].find((f) => f.question === decodedQ)
          if (found) {
            catIndex = i
            targetItem = found
            break
          }
        }
        if (targetItem) {
          this.activeCat = catIndex
          this.$nextTick(() => {
            targetItem.open = true
            this.$nextTick(() => {
              // 滚动到该问题
              const list = this.$el.querySelectorAll('.faq-question .q-text')
              for (const el of list) {
                if (el.textContent.trim() === decodedQ) {
                  el.scrollIntoView({ behavior: 'smooth', block: 'center' })
                  const wrapper = el.closest('.faq-item')
                  if (wrapper) {
                    wrapper.style.transition = 'background 0.6s'
                    wrapper.style.background = '#fff7e6'
                    setTimeout(() => {
                      wrapper.style.background = ''
                    }, 2200)
                  }
                  break
                }
              }
            })
          })
        }
      }
    })
  },
  methods: {
    toggle(item) {
      item.open = !item.open
    }
  }
}
</script>

<style scoped>
.faq-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 40px 0 80px;
}
.faq-container {
  width: 1200px;
  max-width: calc(100% - 40px);
  margin: 0 auto;
}
.breadcrumb-bar {
  font-size: 14px;
  color: #969fa6;
  margin-bottom: 16px;
}
.crumb {
  cursor: pointer;
  color: #3170ff;
}
.crumb:hover {
  text-decoration: underline;
}
.sep {
  margin: 0 8px;
  color: #c0c4cc;
}
.crumb-current {
  color: #606266;
}
.faq-header {
  text-align: center;
  padding: 30px 0 40px;
}
.faq-title {
  font-size: 32px;
  font-weight: 600;
  color: #23262a;
  margin: 0 0 12px;
}
.faq-subtitle {
  font-size: 15px;
  color: #606266;
  margin: 0;
  line-height: 1.7;
}
.faq-body {
  display: flex;
  gap: 24px;
}
.faq-sidebar {
  width: 220px;
  background: #fff;
  border-radius: 8px;
  padding: 16px 0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  flex-shrink: 0;
  height: fit-content;
}
.cat-item {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  font-size: 14px;
  color: #4a4a4a;
  cursor: pointer;
  transition: background 0.2s;
  position: relative;
}
.cat-item:hover {
  background: #f5f7fa;
}
.cat-item.active {
  background: #ecf3ff;
  color: #3170ff;
  font-weight: 500;
}
.cat-item.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #3170ff;
}
.cat-icon {
  margin-right: 10px;
  font-size: 16px;
}
.cat-name {
  flex: 1;
}
.cat-count {
  font-size: 12px;
  background: #f0f1f5;
  color: #606266;
  border-radius: 10px;
  padding: 2px 8px;
}
.cat-item.active .cat-count {
  background: #3170ff;
  color: #fff;
}
.faq-list {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  padding: 24px 32px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}
.cat-title {
  font-size: 22px;
  font-weight: 600;
  color: #23262a;
  margin: 0 0 6px;
}
.cat-desc {
  color: #969fa6;
  font-size: 13px;
  margin: 0 0 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;
}
.faq-item {
  border-bottom: 1px solid #f0f1f5;
}
.faq-question {
  display: flex;
  align-items: center;
  padding: 18px 0;
  cursor: pointer;
  user-select: none;
}
.q-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: #3170ff;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 600;
  margin-right: 12px;
  flex-shrink: 0;
}
.q-text {
  flex: 1;
  font-size: 15px;
  color: #23262a;
  font-weight: 500;
}
.q-arrow {
  font-size: 22px;
  color: #c0c4cc;
  font-weight: 300;
  transition: transform 0.2s;
  margin-left: 12px;
}
.q-arrow.open {
  transform: rotate(45deg);
  color: #3170ff;
}
.faq-answer {
  display: flex;
  padding: 0 0 18px 40px;
  align-items: flex-start;
}
.a-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: #f0f1f5;
  color: #3170ff;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 600;
  margin-right: 12px;
  flex-shrink: 0;
}
.a-text {
  flex: 1;
  font-size: 14px;
  line-height: 1.9;
  color: #4a4a4a;
}
.faq-contact {
  text-align: center;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  margin-top: 24px;
  color: #606266;
  font-size: 14px;
  line-height: 1.9;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}
.faq-contact p {
  margin: 4px 0;
}
@media (max-width: 900px) {
  .faq-body {
    flex-direction: column;
  }
  .faq-sidebar {
    width: 100%;
    display: flex;
    overflow-x: auto;
    padding: 8px;
  }
  .cat-item {
    flex-shrink: 0;
    padding: 8px 14px;
    border-radius: 20px;
    margin-right: 8px;
  }
  .cat-item.active::before {
    display: none;
  }
  .cat-icon {
    margin-right: 4px;
  }
  .faq-list {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/faq.vue